"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchSetStep = exports.StytchStep = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
var StytchStep;
(function (StytchStep) {
    StytchStep[StytchStep["START"] = 0] = "START";
    StytchStep[StytchStep["COMMON_SIGN_IN"] = 1] = "COMMON_SIGN_IN";
    StytchStep[StytchStep["COMMON_SIGN_UP"] = 2] = "COMMON_SIGN_UP";
    StytchStep[StytchStep["EMAIL_AWAIT_SIGN_IN"] = 3] = "EMAIL_AWAIT_SIGN_IN";
    StytchStep[StytchStep["EMAIL_AWAIT_SIGN_UP"] = 4] = "EMAIL_AWAIT_SIGN_UP";
    StytchStep[StytchStep["EMAIL_SIGN_IN"] = 5] = "EMAIL_SIGN_IN";
    StytchStep[StytchStep["EMAIL_SIGN_UP"] = 6] = "EMAIL_SIGN_UP";
    StytchStep[StytchStep["CRYPTO_SIGN_IN"] = 7] = "CRYPTO_SIGN_IN";
    StytchStep[StytchStep["CRYPTO_SIGN_UP"] = 8] = "CRYPTO_SIGN_UP";
    StytchStep[StytchStep["PHONE_EXCHANGE_CODE_SIGN_IN"] = 9] = "PHONE_EXCHANGE_CODE_SIGN_IN";
    StytchStep[StytchStep["PHONE_EXCHANGE_CODE_SIGN_UP"] = 10] = "PHONE_EXCHANGE_CODE_SIGN_UP";
    StytchStep[StytchStep["PHONE_EXCHANGE_CODE_SIGN_UP_SUCCESS"] = 11] = "PHONE_EXCHANGE_CODE_SIGN_UP_SUCCESS";
    StytchStep[StytchStep["PHONE_SIGN_IN"] = 12] = "PHONE_SIGN_IN";
    StytchStep[StytchStep["PHONE_SIGN_UP"] = 13] = "PHONE_SIGN_UP";
})(StytchStep = exports.StytchStep || (exports.StytchStep = {}));
exports.stytchSetStep = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/SET_STEP');
